var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllocatedSpotsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 2.8125C3.5 1.88086 4.28385 1.125 5.25 1.125H15.75C16.7161 1.125 17.5 1.88086 17.5 2.8125V13.5H3.5V2.8125ZM14.9115 4.46484C14.5687 4.13438 14.0146 4.13438 13.6755 4.46484L9.62865 8.36719L7.9151 6.71484C7.5724 6.38438 7.01823 6.38438 6.67917 6.71484C6.3401 7.04531 6.33646 7.57969 6.67917 7.90664L9.0125 10.1566C9.35521 10.4871 9.90938 10.4871 10.2484 10.1566L14.9115 5.66016C15.2542 5.32969 15.2542 4.79531 14.9115 4.46836V4.46484ZM0 11.8125C0 10.8809 0.783854 10.125 1.75 10.125H2.33333V14.625H18.6667V10.125H19.25C20.2161 10.125 21 10.8809 21 11.8125V15.1875C21 16.1191 20.2161 16.875 19.25 16.875H1.75C0.783854 16.875 0 16.1191 0 15.1875V11.8125Z",
    fill: "#1D5AB9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllocatedSpotsIcon);
export default __webpack_public_path__ + "static/media/allocatedSpotsIcon.ca171a3892556093fb5c5c2899dda7d9.svg";
export { ForwardRef as ReactComponent };